export default __webpack_public_path__ + "static/media/category5.0e55aa3a.png";